import React from "react";
import "./pdf.css";
import { SavingsCard } from "../../components/molecules/savings-card";
import { SavingsPrint } from "../../components/molecules/savings-print";
import { SECTIONS } from "../../constants/sections";
import { Graph } from "../../components/molecules/graph";
import { UNITS } from "../../constants/units";
import { useStore } from "../../store";
import { MimboxData } from "../../interfaces/mimbox-data";
import { getDateFormat } from "../../utils/get-date-format";
import { getValueWithUnit } from "../../utils/units";

export const Pdf = () => {
  const { data = {} as MimboxData, loading } = useStore();
  const useGrams = data?.carbonDioxideSavings < 1;

  const {
    microPlasticEmissionsWithoutMimbox = 0,
    microPlasticEmissionsWithMimbox = 0,
    cO2NoMimbox: cO2NoMimboxKG,
    cO2Mimbox: cO2MimboxKG,
  } = data;
  const lowEmissions = microPlasticEmissionsWithMimbox < 1;

  const cO2NoMimbox = useGrams
    ? Math.round(cO2NoMimboxKG * 1000)
    : cO2NoMimboxKG;
  const cO2Mimbox = useGrams ? Math.round(cO2MimboxKG * 1000) : cO2MimboxKG;

  return (
    <>
      <div className="Pdf">
        <SavingsCard
          value="Besparingar"
          text={`${getDateFormat(data?.star)} till ${getDateFormat(data?.end)}`}
          className="header"
          isLoading={loading}
          tag="h2"
        />
        {/* ------ WATER Section ------ */}
        <div className="print-section left-info">
          <SavingsPrint
            icon="water"
            text={SECTIONS.WATER}
            bullets={[
              `${getValueWithUnit(data?.waterSavedL, UNITS.LITER)} har sparats`,
              `Återvinningsgrad på ${getValueWithUnit(
                data?.waterReductionInPercent,
                UNITS.PERCENT
              )}`,
            ]}
          />
          <Graph
            description="Vattenförbrukning"
            max={data?.totalWaterL}
            min={data?.tapWaterL}
            unit={UNITS.LITER}
            print
          />
        </div>
        <div className="divider" />
        {/* ------ MICROPLASTIC Section ------ */}
        <div className="print-section right-info">
          <Graph
            description="Mikroplastutsläpp"
            max={
              lowEmissions
                ? microPlasticEmissionsWithoutMimbox * 1000
                : microPlasticEmissionsWithoutMimbox
            }
            min={
              lowEmissions
                ? microPlasticEmissionsWithMimbox * 1000
                : microPlasticEmissionsWithMimbox
            }
            unit={lowEmissions ? UNITS.GRAMS : UNITS.KILO}
            print
          />
          <SavingsPrint
            icon="microplastics"
            text={SECTIONS.MICROPLASTICS}
            bullets={[
              `${getValueWithUnit(
                data?.microPlasticsSavings,
                UNITS.GRAMS
              )} minskat utsläpp`,
              `Minskning på ${getValueWithUnit(
                data?.microPlasticReductionInPercent,
                UNITS.PERCENT
              )}`,
            ]}
          />
        </div>
        <div className="divider" />
        {/* ------ CARBON DIOXIDE Section ------ */}
        <div className="print-section left-info">
          <SavingsPrint
            icon="carbon-dioxide"
            text={SECTIONS.CARBON_DIOXIDE}
            bullets={[
              `${getValueWithUnit(
                data?.carbonDioxideSavings,
                UNITS.KILO
              )} minskat utsläpp`,
              `Minskning på ${getValueWithUnit(
                data?.carbonDioxideRed,
                UNITS.PERCENT
              )}`,
            ]}
          />
          <Graph
            description="CO2 Utsläpp"
            max={cO2NoMimbox}
            min={cO2Mimbox}
            unit={UNITS.GRAMS}
            print
          />
        </div>
      </div>
    </>
  );
};
